function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import useMediaStreamTrack from '../hooks/useMediaStreamTrack'; //import useScreenSize from '../hooks/useScreenSize';

import useVideoTrackDimensions from '../hooks/useVideoTrackDimensions';
export default function VideoTrack(_ref) {
  var _dimensions$height, _dimensions$width;

  var track = _ref.track,
      isLocal = _ref.isLocal,
      priority = _ref.priority;
  var ref = useRef(null);
  var mediaStreamTrack = useMediaStreamTrack(track);
  var _window = window,
      height = _window.innerHeight,
      width = _window.innerWidth;
  var dimensions = useVideoTrackDimensions(track, isLocal);
  var isPortrait = ((_dimensions$height = dimensions === null || dimensions === void 0 ? void 0 : dimensions.height) !== null && _dimensions$height !== void 0 ? _dimensions$height : 0) > ((_dimensions$width = dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) !== null && _dimensions$width !== void 0 ? _dimensions$width : 0);
  var isLocalScreenPortrait = height > width;

  var videoStyle = function videoStyle() {
    var defaultStyle = {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    };

    if (isLocal && isFrontFacing) {
      defaultStyle.transform = 'scaleX(-1)';
    }

    if (track.name.includes('screen')) {
      return _extends({}, defaultStyle, {
        objectFit: 'contain'
      });
    }

    if (isPortrait && !isLocalScreenPortrait) {
      return _extends({}, defaultStyle, {
        height: '133%',
        marginTop: height * 0,
        //height*0.3,
        objectFit: 'contain'
      });
    }

    return defaultStyle;
  }; // https://github.com/twilio/twilio-video.js/issues/1632
  // https://bugs.webkit.org/show_bug.cgi?id=230922#c12


  function shimVideoElement(track, el) {
    var wasInterrupted = false;

    var onPause = function onPause() {
      wasInterrupted = true;
    };

    var onPlay = function onPlay() {
      if (wasInterrupted) {
        track.detach(el);
        track.attach(el);
        wasInterrupted = false;
      }
    };

    el.addEventListener('pause', onPause);
    el.addEventListener('play', onPlay); // Track this element so we can remove the listeners

    return {
      onPause: onPause,
      onPlay: onPlay
    };
  }

  useEffect(function () {
    var el = ref.current;
    el.muted = true;

    if (track.setPriority && priority) {
      track.setPriority(priority);
    }

    track.attach(el);

    var _shimVideoElement = shimVideoElement(track, el),
        onPause = _shimVideoElement.onPause,
        onPlay = _shimVideoElement.onPlay;

    return function () {
      el.removeEventListener('pause', onPause);
      el.removeEventListener('play', onPlay);
      track.detach(el);
      el.srcObject = null; // recommended by Twilio to prevent leaks in  CHrome: https://github.com/twilio/twilio-video.js/releases/tag/2.15.3

      if (track.setPriority && priority) {
        // Passing `null` to setPriority will set the track's priority to that which it was published with.
        track.setPriority(null);
      }
    };
  }, [track, priority]);
  var isFrontFacing = mediaStreamTrack && mediaStreamTrack.getSettings().facingMode !== 'environment';
  return /*#__PURE__*/React.createElement("video", {
    ref: ref,
    style: videoStyle()
  });
}